export default "__VITE_ASSET__BkJRDDqD__"